import React, { useState } from "react";
import { ThemeProvider } from "styled-components";
import MobileRoutes from "./router";
import AppWrapper from "./App.style";
import { IonApp } from "@ionic/react";
import { IntlProvider } from "react-intl";
import { useSelector } from "react-redux";
import Notifier from "./features/notifications";
import { QueryClient, QueryClientProvider } from "react-query";
import { setApiPrefix } from "./api/server";

const queryClient = new QueryClient();

const MobileApp = () => {
  const currentAppLocale = useSelector((state) => state.auth.currentAppLocale);
  setApiPrefix();
  const [fontSize, setFontSize] = useState(
    +localStorage.getItem("textSize") || 1
  );

  window.addEventListener("storage", () => {
    setFontSize(+localStorage.getItem("textSize"));
  });

  return (
    <IntlProvider
      onError={(err) => {
        if (err.code === "MISSING_TRANSLATION") {
          // console.warn("Missing translation", err.message);
          return;
        }
        throw err;
      }}
      locale={currentAppLocale.locale}
      messages={currentAppLocale.messages}
    >
      <QueryClientProvider client={queryClient}>
        <ThemeProvider
          theme={{
            textColor: [
              "rgba(0, 0, 0, 0.85)", //0: text color
            ],
          }}
        >
          <Notifier />
          <AppWrapper
            direction={currentAppLocale.direction}
            textSize={fontSize}
          >
            <IonApp dir={currentAppLocale.direction}>
              <MobileRoutes />
            </IonApp>
          </AppWrapper>
        </ThemeProvider>
      </QueryClientProvider>
    </IntlProvider>
  );
};

export default MobileApp;
